import React, { useState, useEffect,useCallback } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { get, post } from "../common/api";

require("es6-promise").polyfill()
require("isomorphic-fetch")


function transformToItinDetailFormat(recommendationResponse) {
  return recommendationResponse.map((poi) => ({
    id: poi.poi_id,
    start_time: poi.start,
    end_time: poi.end,
    poi: {
      id: poi.poi_id,
      name: poi.name,
      min_spending: poi.price,
      max_spending: poi.price,
      image_url: poi.image_url,
      rating: {
        rating: poi.rating,
      },
    },
  }));
}

function Recommendation() {
  const auth = useSelector((state) => state.auth);
  const history = useHistory();

  const [conflict, setConflict] = useState(false);
  const [message,setMessage] = useState('');


  const [budget, setBudget] = useState();
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState();
  const [start, setStart] = useState();
  const [end, setEnd] = useState();


  const isInvalidRange = useCallback((value) => {
    if (start >= end){
      console.log(start)
      console.log(end)
      setConflict(true)
     
    }// eslint-disable-next-line 
  }, [start,end,conflict])

  const checkConflictAll = useCallback((value) => {
    setConflict(false);
    isInvalidRange();
  }, [isInvalidRange])




  useEffect(() => {
    const fetchData = async () => {
      const response = await get("/api/cities/");
      setCities(response.data);
    };

    fetchData();
    checkConflictAll();
  }, [start,end,checkConflictAll]);

  let body = {};
  body["budget"] = parseInt(budget);
  body["city"] = parseInt(city);
  body["start"] = start;
  body["end"] = end;

  const recommendation = async () => {
    try {
      const res = await post("/api/generate-itin/", body, {
        headers: {
          Authorization: `Token ${auth.token}`,
        },
      });

      history.push("/itin/create/finalize", {
        itinPoiList: transformToItinDetailFormat(res.data),
      });
    } catch (e) {
      console.log("error when getting recommendation: ", e);
    }
  };

  const onSubmit = (event) => {
  event.preventDefault();
  if (conflict === true){
      setMessage("Gagal menambahkan! Tanggal Mulai harus lebih awal dari Tanggal Berakhir");
  }
  else {
    recommendation();
  }};

  return (
    <div className="fb container-sm">
      <div className="d-flex justify-content-center text-center profile-title">
        <p className="h4">Rekomendasi ITIN</p>
      </div>

      <div className="d-flex justify-content-center">
        <form onSubmit={onSubmit}>
          <div className="mb-4 text-start">
            <label className="form-label body">Budget</label>
            <input
              type="text"
              className="form-control field"
              alt="budget"
              placeholder="Masukan input berupa angka"
              value={budget}
              onInput={(e) =>
                setBudget(
                  e.target.value
                    .replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')
                )
              }
              
          
            required />
          </div>

          <div className="mb-4 text-start">
            <label className="form-label body">Lokasi</label>
            <select
              className="form-control field"
              onInput={(e) => setCity(e.target.value)}
              required
            >
              <option value="">Pilih Kota</option>
              {cities.map((city) => (
                <option key={city.id} value={city.id}>
                  {city.name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-4 text-start">
            <label className="form-label body">Tanggal Mulai</label>
            <input
              type="datetime-local"
              alt="start"
              className="form-control field"
              onChange={(e) => setStart(e.target.value)}
              required
            />
          </div>

          <div className="mb-4 text-start">
            <label className="form-label body">Tanggal Berakhir</label>
            <input
              type="datetime-local"
              alt="end"
              className="form-control field"
              onChange={(e) => setEnd(e.target.value)}
              required
            />
          </div>

          { <div className="d-flex justify-content-center warn">
        {conflict && <h4 className="mt-3">{message} </h4>}
        </div> }


          <div className="d-flex justify-content-center mt-5">
            <Link to="/itin/create" className="button-outline button">Batal</Link>
            <button
              className="button-filled button"
              type="submit"
             
            >
              Buat ITIN
            </button>
          </div>
        </form>
      </div>
    </div>
  );
  
}


export default Recommendation;
